import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function (applicationId) {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/LicenceApplication/GetLicenceImagesByLicenceId";

        const params = {
            licenceApplicationId: applicationId
        };

        GET(url, params)
            .then(function (response) {
                if (response.status === 200) {
                    
                    dispatch({
                        type: "LICENCE_IMAGES_RETRIEVED",
                        data: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}

